import { useEffect } from 'react'

import type { IconProp, IconProps } from '../icon'

import { useStyleConfig, vui } from '../core'
import Icon from '../icon'
import { cs } from '../utils'
import { useButtonContext } from './context'

const isConceptualIcon = (name?: IconProp) => name?.startsWith('con')

/** Displays an icon within the Button. */
export const ButtonIcon = vui<'svg', IconProps>((props, ref) => {
  const { className, name, ...rest } = props
  const buttonContext = useButtonContext()
  const styles = useStyleConfig('Button', buttonContext)

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production' && isConceptualIcon(name)) {
      console.warn(
        `[ButtonIcon] Conceptual icon "${name}" is not supported inside a Button. Use a UI icon (name starting with "ui") instead.`,
      )
    }
  }, [name])

  if (isConceptualIcon(name)) return null

  const iconSize = `var(--vui-button-icon-size, ${styles.icon?.fontSize || '1rem'})`

  return (
    <Icon
      className={cs('vui-buttonIcon', className)}
      fontSize={iconSize}
      h={iconSize}
      w={iconSize}
      name={name}
      ref={ref}
      {...rest}
    />
  )
})

ButtonIcon.displayName = 'ButtonIcon'
export default ButtonIcon
